import { IoCaretBackOutline } from "react-icons/io5";
import { TbBell, TbSettings } from "react-icons/tb";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "../Core/Button";
import ProfileDetailsComponent from "../ProfileComponent";
import StateSwitcher from "../StateSwitcher";
import Classes from "./AfterLoginHeader.module.css";
import { useMediaQuery } from "@/customHooks/useMediaQuery";

export const AfterLoginHeader = ({ header, drawerBtn }) => {
  const { unReadNotificationCount } = useSelector(
    (state) => state.commonReducer
  );
  const isMobile = useMediaQuery("(max-width: 600px)");

  const navigate = useNavigate();

  return (
    <div className={Classes.loginHeader}>
      <div className={Classes.navbarContainer}>
        {drawerBtn && drawerBtn}
        <div className={Classes.mainHeader}>
          {false && (
            <div className={Classes.backBtn} onClick={() => navigate(-1)}>
              <IoCaretBackOutline />
            </div>
          )}
          {header && <h1 className={Classes.heading}>{header}</h1>}
        </div>
        <div
          className={Classes.notification_header}
          onClick={() => navigate("/notifications")}
        >
          {unReadNotificationCount > 0 && (
            <p className={Classes.unreadNotificationCount}>
              {unReadNotificationCount > 9 ? "9+" : unReadNotificationCount}
            </p>
          )}
          <Button
            size="sm"
            variant="bordered"
            className={Classes.notificationBtn}
          >
            <TbBell size={18} color="var(--text-color)" />
          </Button>
        </div>
        {!isMobile && (
          <div
            className={Classes.iconWrapper}
            onClick={() => navigate("/profile-settings")}
          >
            <TbSettings size={18} cursor="pointer" color="var(--text-color)" />
          </div>
        )}
        <StateSwitcher />

        <ProfileDetailsComponent />
      </div>
    </div>
  );
};
